<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="Devices-topCurve-wrapper lxn-w100">
      <CustomCurve>
        <TopNav @rightTextClick="addNewDevice" v-if="$store.getters.language.texts.isRTL" :rightText="$store.getters.language.texts.Devices_addNewDevice" rightIcon="plus" leftText="" leftIcon="" centerText=""></TopNav>
        <TopNav @leftTextClick="addNewDevice" v-else rightText="" rightIcon="" :leftText="$store.getters.language.texts.Devices_addNewDevice" leftIcon="plus" centerText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="Devices-main-wrapper lxn-pos-rel">
      <searchInput @clearSearchText="searchText = ''" v-model="searchText">
      </searchInput>
      <div v-if="!searchText.length" class="lxn-w100">
        <div v-if="!hubCount" :class="[$store.getters.language.directionClass, $store.getters.language.font]" class="Devices-noHubs lxn-margin-auto lxn-border-round lxn-pos-rel lxn-text-center">
          {{$store.getters.language.texts.Devices_noHubs}}
        </div>
        <Hub v-for="(hub, index) in hubs" :key="hub.uuid" :index="index">
          <div v-if="!nodesInHub(hub.uuid).length" :class="[$store.getters.language.directionClass, $store.getters.language.font]" class="lxn-text-center">
            {{$store.getters.language.texts.Devices_noNodes}}
          </div>
          <Node v-for="nodeIndex in nodesInHub(hub.uuid)" :key="nodeIndex" :index="nodeIndex">
          </Node>
        </Hub>
      </div>
      <div v-else class="Devices-search-result lxn-w100 lxn-margin-auto lxn-border-round lxn-pos-rel">
        <div v-if="searchResults.length">
          <div v-for="(result, index) in searchResults" :key="index" class="Devices-wrapper-searchResult lxn-w100 lxn-border-round lxn-overflow-hidden">
            <div class="Devices-searchResult-icon lxn-h100" :class="$store.getters.language.floatClass">
              <ButtonIcon :size="40" bgColor="#53636C" :icon="result.icon1" iconColor="#FFFFFF" :padding="8" />
            </div>
            <div class="Devices-wrapper-searchResult-text lxn-h100" :class="$store.getters.language.floatClass">
              <div class="Devices-searchResult-text lxn-small-text lxn-h100" :class="[$store.getters.language.font, $store.getters.language.directionClass, $store.getters.language.textAlignClass]">
                {{result.name}}
              </div>
            </div>
            <div class="Devices-searchResult-setting lxn-h100" :class="$store.getters.language.floatClass">
              <ButtonIcon @click="$router.push(result.link)" :size="50" bgColor="#1EA5DE" :icon="result.icon2" iconColor="#FFFFFF" :padding="8" />
            </div>
          </div>
        </div>
        <div v-else :class="[$store.getters.language.directionClass, $store.getters.language.font]" class="lxn-text-center">
          {{$store.getters.language.texts.Devices_searchNotFound}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import searchInput from '@/components/Home/Devices/searchInput.vue'
import Hub from '@/components/Home/Devices/Hub.vue'
import Node from '@/components/Home/Devices/Node.vue'
import ButtonIcon from '@/components/ButtonIcon.vue'


export default {
  name: 'devices',
  components: {
    CustomCurve,
    TopNav,
    searchInput,
    Hub,
    Node,
    ButtonIcon
  },
  data: function() {
    return {
      searchText: ''
    }
  },
  computed: {
    hubs: function() {
      return this.$store.state.hubs;
    },
    hubCount: function() {
      return this.hubs.length
    },
    searchResults: function() {
      var searchResult = [];
      var i = 0;
      var j = 0;

      if(this.searchText.length != 0){
        for(i = 0; i < this.$store.state.hubs.length; i++){
          if( this.$store.state.hubs[i].name.toLowerCase().search(this.searchText.toLowerCase()) !== -1){
            searchResult.push({
              icon1: 'online',
              icon2: 'cog',
              name: this.$store.state.hubs[i].name,
              link: '/hubSettings/' + this.$store.state.hubs[i].uuid
            })
          }
        }

        for(i = 0; i < this.$store.state.nodes.length; i++){
          var hubName = this.$store.getters.getHubByUUID(this.$store.state.nodes[i].hubUUID).name;
          var nodeName = this.$store.state.nodes[i].name;
          if( this.$store.state.nodes[i].name.toLowerCase().search(this.searchText.toLowerCase()) !== -1){
            if(this.$store.state.nodes[i].isPaired){
              searchResult.push({
                icon1: 'dashboard',
                icon2: 'cog',
                name: hubName + ' > ' + nodeName,
                link: '/node' + this.$store.state.nodes[i].deviceType + 'Settings/' + this.$store.state.nodes[i].uuid,
              })
            } else {
              searchResult.push({
                icon1: 'dashboard',
                icon2: 'pair',
                name: hubName + ' > ' + nodeName,
                link: '/pairNode/' + this.$store.state.nodes[i].uuid,
              })
            }
          }
          if(this.$store.state.nodes[i].isPaired){
            for(j = 0; j < this.$store.state.nodes[i].inputs.length; j++){
              if( this.$store.state.nodes[i].inputs[j].name.toLowerCase().search(this.searchText.toLowerCase()) !== -1){
                searchResult.push({
                  icon1: 'switch',
                  icon2: 'cog',
                  name: hubName + ' > ' + nodeName + ' > ' + this.$store.state.nodes[i].inputs[j].name,
                  link: '/Input' + this.$store.state.nodes[i].inputs[j].type + 'Settings/' + this.$store.state.nodes[i].uuid + '/' + j,
                })
              }
            }

            for(j = 0; j < this.$store.state.nodes[i].outputs.length; j++){
              if( this.$store.state.nodes[i].outputs[j].name.toLowerCase().search(this.searchText.toLowerCase()) !== -1){
                searchResult.push({
                  icon1: 'lamp',
                  icon2: 'cog',
                  name: hubName + ' > ' + nodeName + ' > ' + this.$store.state.nodes[i].outputs[j].name,
                  link: '/Output' + this.$store.state.nodes[i].outputs[j].type + 'Settings/' + this.$store.state.nodes[i].uuid + '/' + j,
                })
              }
            }
          }
        }
      }
      return searchResult;
    }
  },
  methods: {
    nodesInHub: function (hubId) {
      var nodesIndices = [];
      for(var i = 0; i < this.$store.state.nodes.length; i++){
        if(this.$store.state.nodes[i].hubUUID === hubId){
          nodesIndices.push(i);
        }
      }
      return nodesIndices;
    },
    channelsInNode: function (nodeIndex) {
      var nodeChannels = [];
      for(var i = 0; i < this.$store.state.nodes[nodeIndex].channels.length; i++){
        nodeChannels.push(i);
      }
      return nodeChannels;
    },
    hubName: function (hubId) {
      for(var i = 0; i < this.$store.state.hubs.length; i++){
        if( this.$store.state.hubs[i].uuid === hubId ){
          return this.$store.state.hubs[i].name;
        }
      }
    },
    addNewDevice: function () {
      this.$router.push('/addDevice');
    },
    isNodePaired: function (nodeIndex) {
      return this.$store.state.nodes[nodeIndex].isPaired;
    },
  }
}
</script>

<style>
  .Devices-topCurve-wrapper {
    height: 150px;
  }
  .Devices-main-wrapper {
    margin-top: -100px;
    margin-bottom: 14px;
    z-index: 2;
  }
  .Devices-noHubs {
    width: calc(100% - 36px);
    background-color: #ffffff;
    height: 100px;
    line-height: 75px;
    padding: 10px;
    z-index: 2;
  }
  .Devices-search-result {
    width: calc(100% - 36px);
    background-color: #ffffff;
    padding: 10px;
    z-index: 2;
  }
  .Devices-wrapper-searchResult {
    height: 50px;
    background-color: #ECECEC;
    margin-top: 14px;
  }
  .Devices-searchResult-icon {
    width: 50px;
    padding: 5px;
  }
  .Devices-wrapper-searchResult-text {
    width: calc(100% - 100px);
  }
  .Devices-searchResult-text {
    line-height: 50px;
    padding-left: 5px;
    padding-right: 5px;
    color: #52626C;
  }
  .Devices-searchResult-setting {
    width: 50px;
  }
</style>
